import dayjs from "dayjs";
import { hasCookie } from "../../lib/utils/cookies";
import {cache} from "../../lib/utils/storage";
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime)

function formatDateTimes(){
    document.querySelectorAll<HTMLElement>('time[datetime]').forEach((el: HTMLElement) => {
        el.innerHTML = dayjs(el.getAttribute("datetime")).format(
            el.dataset.format || '');

    })
}

function formatTimeTo(){
    const nowDt = new Date();
    const next24h = new Date(nowDt.getTime() + 24*60*60*1000);
    const templateAirTag = document.getElementById("tag-on-air");
    const templateAirTagStatic = document.querySelector<HTMLTemplateElement>("#tag-on-air-top");

    document.querySelectorAll<HTMLElement>('.time-to-event').forEach((el: HTMLElement) => {
        if (!el.dataset["airStart"]){
            return;
        }
        const airStart = new Date(el.dataset["airStart"]);

        if (airStart > nowDt && airStart < next24h){
            el.textContent = dayjs(airStart).fromNow();
            el.classList.remove("hidden");
        }
        if (!el.dataset["airEnd"]){
            return;
        }
        const airEnd = new Date(el.dataset["airEnd"]);

        if (airStart < nowDt && airEnd > nowDt && templateAirTag && templateAirTagStatic){
            el.innerHTML = templateAirTag.innerHTML;
            el.classList.remove("hidden");

            const overlay = document.querySelector(`.overlays[data-vvid="${el.dataset['vvid']}"]`);
            if (overlay){
                overlay.append(templateAirTagStatic.content.cloneNode(true));
            }
        }
    })
}

function scheduleFilter(){
    const el = document.querySelector<HTMLElement>('#categories-filter');
    if (!el){
        return
    }

    // Options for the observer (which mutations to observe)
    const config = { attributes: true };

// Callback function to execute when mutations are observed
    const callback = (mutationList: MutationRecord[]) => {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
                if ((mutation.target as HTMLElement).classList.contains("hidden")){
                    const button = document.querySelector<HTMLButtonElement>('#categories-filter button.apply');
                    if (button){
                        button.click();
                    }
                }
            }
        }
    };

// Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
    observer.observe(el, config);

    const aBox = document.querySelector<HTMLInputElement>('#categories-filter #all-sports');
    const button = document.querySelector<HTMLButtonElement>('#categories-filter button.apply');
    const buttonCancel = document.querySelector<HTMLButtonElement>('#categories-filter button.cancel');
    const btnClear = document.querySelector<HTMLButtonElement>('.clear-categories');

    if (btnClear){
        btnClear.addEventListener('click', function (){
            const url = new URL(document.location.href);
            url.searchParams.delete('categories');
            cache("fite.cf", [], -0)
            document.location.href = url.href;
        })
    }

    if (aBox){
        aBox.addEventListener('change', function (){
            if (this.checked){
                 document.querySelectorAll<HTMLInputElement>('#categories-filter input').forEach((el: HTMLInputElement) => {
                     if (el.id === 'all-sports')
                        return;
                     el.checked = false;
                 });
            }
        })
    }

    el.addEventListener('change', function (){
        let hasFilter = false;
        const categories: string[] = [];

        const inputList = document.querySelectorAll<HTMLInputElement>('#categories-filter input');
        inputList.forEach((el: HTMLInputElement) => {
            if (el.id !== 'all-sports' && el.checked){
                categories.push(el.value)
                hasFilter = true;
            }
        })

        if (categories.length === inputList.length - 1){
            hasFilter = false;
            inputList.forEach((el: HTMLInputElement) => {
                if (el.id !== 'all-sports' && el.checked) {
                    el.checked = false;
                }
            })
        }

        if (aBox){
            aBox.checked = !hasFilter;
        }
    })

    if (button){
        const submitListener = function (e: MouseEvent){
            e.preventDefault();

            let categories: string[] = []
            document.querySelectorAll<HTMLInputElement>('#categories-filter input').forEach((el: HTMLInputElement) => {
                if (el.id !== 'all-sports' && el.checked){
                    categories.push(el.value)
                }
            });
            categories = categories.sort();

            const url = new URL(document.location.href);
            if (categories.length === 0){
                url.searchParams.delete('categories');
            }else{
                url.searchParams.set('categories', categories.join(','));
            }
            if (url.href !== document.location.href){
                cache("fite.cf", categories, -1)
                document.location.href = url.href;
                button.removeEventListener("click", submitListener);
                observer.disconnect();
                const trigger = document.querySelector<HTMLInputElement>("[data-dropdown-toggle='categories-filter']")
                if (trigger){
                    trigger.disabled = true
                }
            }
            const body = document.querySelector('body');
            if (body){
                body.click();
            }
        }
        button.addEventListener('click', submitListener)
    }
    if (buttonCancel){
        buttonCancel.addEventListener('click', () => {
            document.querySelector<HTMLInputElement>("[data-dropdown-toggle='categories-filter']")?.click()

            const url = new URL(document.location.href);
            const categories: string[] = [];
            if( url.searchParams.has('categories')){
                url.searchParams.get("categories")?.split(",").forEach((category: string) => {
                    categories.push(category);
                })
            }
            document.querySelectorAll<HTMLInputElement>('#categories-filter input').forEach((el: HTMLInputElement) => {
                if(categories.length === 0){
                    if(el.id === 'all-sports'){
                        el.checked = true;
                    }else{
                        el.checked = false;
                    }
                }else{
                    if(categories.includes(el.value)){
                        el.checked = true;
                    }else{
                        el.checked = false;
                    }
                }
            });
        })
    }
}

function weeklyTabSwitcher(this: HTMLElement, e: MouseEvent){
    e.preventDefault();
    const classActive = "bg-mono-ns-100";
    const classInactive = "bg-mono-ns-200";
    const selectedWeek = this.dataset["number"];
    if (!selectedWeek)
        return;

    document.querySelectorAll<HTMLLinkElement>('.weekly-selector a').forEach((el: HTMLLinkElement) => {
        el.classList.remove(classActive);
        el.classList.add(classInactive);
        if (el.dataset["number"] === selectedWeek){
            el.classList.add(classActive);
            el.classList.remove(classInactive);
        }
    });
    document.querySelectorAll<HTMLLIElement>(`li[data-week]:not([data-week="${selectedWeek}"])`).forEach((el) => {
        el.classList.add("hidden");
    })

    document.querySelectorAll<HTMLElement>(`.event-list li[data-week="${selectedWeek}"]`).forEach((el) => {
        el.classList.remove("hidden");
    })
}
function initWeeklyTabSwitcher(){
    document.querySelectorAll<HTMLLinkElement>('.weekly-selector a').forEach((el: HTMLLinkElement) => {
        if (!el.dataset.number)
            return;
        el.addEventListener("click", weeklyTabSwitcher);
    })
}

function eventLoader(this: HTMLLinkElement, e: MouseEvent){
    e.preventDefault();
    if (this.disabled)
        return
    this.disabled = true;
    const targetEl = document.querySelector<HTMLElement>('.event-list');

    fetch(
        this.href, {
            credentials: "include",
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        })
        .then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.text()
            }else{
                throw new Error('Error');
            }
        })
        .then((response) => {
            if (this.parentElement)
                this.parentElement.remove();
            if (targetEl){
                const template = document.createElement('template');
                template.innerHTML = response;
                targetEl.append(template.content);
                formatDateTimes();
                document.querySelectorAll<HTMLElement>('.event-list li.hidden').forEach((el) => {
                    el.classList.remove("hidden");
                })
                initEventLoader();
            }
        })
        .catch((error) => {
            console.log(error)
        })
}
function initEventLoader(){
    const el = document.querySelector<HTMLLinkElement>('.show-more');
    if (!el)
        return;

    el.addEventListener("click", eventLoader);
}

function initNotifyMe(){
    if (hasCookie('_fus', document.cookie) || hasCookie('eid', document.cookie)){
        return;
    }
    const navBtn = document.querySelector<HTMLElement>('[data-modal="subscribe-modal"]');
    const modalEl = document.querySelector<HTMLElement>("#subscribe-modal");

    if (!navBtn || !navBtn.parentElement || !modalEl)
        return;

    const modalDismissEl = modalEl.querySelector<HTMLElement>('.modal-dismiss');
    if (modalDismissEl){
        modalDismissEl.addEventListener('click', function (){
            toggleElementVisibility(modalEl);
        })
    }

    navBtn.parentElement.classList.remove('hidden');

    navBtn.addEventListener('click', function (){
        toggleElementVisibility(modalEl);
    })

    const formEl = modalEl.querySelector<HTMLFormElement>('form');
    if (formEl){
        formEl.addEventListener('submit', function (this: HTMLFormElement, e){
            e.preventDefault();
            const formData = new FormData(this);
            const errorUl = this.querySelector('.form-error');
            const submitBtn = this.querySelector<HTMLButtonElement>('[type="submit"]');

            if (submitBtn){
                submitBtn.disabled = true;
            }
            if (errorUl){
                errorUl.innerHTML = '';
            }

            fetch(this.action, {
                method: 'POST',
                cache: 'no-cache',
                credentials: "include",
                body: formData
            }).then((response) => response.json())
                .then((data) => {
                    if (data.status === 'ok'){
                        navBtn.remove();
                        toggleElementVisibility(modalEl);
                    }else if (data.status === "error"){
                        if (errorUl){
                            for (const section in data.errors){
                                 for (const row in (data.errors[section] as any)){
                                     const el = document.createElement('li');
                                     el.textContent = data.errors[section][row];
                                     errorUl.append(el);
                                 }
                            }
                        }
                        if (submitBtn){
                            submitBtn.disabled = false;
                        }
                    }
                })
        });
    }
}

function toggleElementVisibility(el: HTMLElement){
    if (el.classList.contains('hidden')){
        el.classList.remove('hidden');
    }else{
        el.classList.add('hidden');
    }
}

formatDateTimes();
formatTimeTo();
scheduleFilter();
initWeeklyTabSwitcher();
initEventLoader();
initNotifyMe();
